/**
 * EAA-2031: a generated lesson arrived with an empty required title although the set,
 * its page or its description already said what it is about — so the record could not
 * be saved until the teacher typed one. The editor fills the title from those.
 */

import type { LessonMCQData } from './schema';

const MAX_TITLE_LENGTH = 120;

function firstLine(text: string | undefined): string {
    const line = (text ?? '').split(/\r?\n/).find((l) => l.trim()) ?? '';
    const clean = line.trim();
    if (clean.length <= MAX_TITLE_LENGTH) return clean;
    return `${clean.slice(0, MAX_TITLE_LENGTH - 1).trimEnd()}…`;
}

/** The title to show for ``data``: its own, else the set's, the page's, or the description's first line. */
export function deriveLessonTitle(
    data: Partial<LessonMCQData> | undefined,
    fallback?: string
): string {
    const candidates = [
        data?.title,
        data?.questionSet?.title,
        data?.lessonContent?.title,
        fallback,
        data?.description,
    ];
    for (const candidate of candidates) {
        const title = firstLine(candidate);
        if (title) return title;
    }
    return '';
}
